export default {
  ISM标准管理平台: 'ISM standard',
  标准管理: 'standard',
  标准库管理: 'Standard Database',
  标准属性管理: 'Standard Attribute',
  类别类型管理: 'class type',
  度量单位管理: 'unit of measure',
  标识管理: 'identification',
  模型管理: 'model',
  类别管理: 'class',
  标准查看: 'standard view',
  变更申请管理: 'change application',
  类别检索: 'class retrieval',
  数据模型详情: 'data model detail',
  新增度量管理: 'crate measure',
  数据字典管理: 'data dictionnary',
  实体检索: 'class retrieval',
  数据明细: 'data detail',
  数据标准管理: 'Data Standards',
  实体管理: 'Entity Management',
  实体标签: 'Entity labels',
  系统管理: 'System Administration',
  数据字典: 'Data Dictionary',
  信息对象解析: 'Information object parsing',
  对象属性解析规则: 'Object property parsing rules',
  对象编码解析规则: 'Object encoding parsing rules',
  对象解析任务配置: 'Object resolution task configuration',
  对象解析任务进度: 'Object resolution task progress',
  数据采集管理: 'Data acquisition',
  实体对象: 'Entity object',
  实体文档: 'Entity documents',
  关联关系: 'Associative relationships',
  关联对象: 'Associated objects',
  数据源管理: 'Data source management',
  ETL工具: 'ETL tools',
  采集对账: 'Collect reconciliation',
  数据质量管理: 'Data quality',
  数据规则设置: 'Data rule settings',
  质检源管理: 'Quality inspection source management',
  数据质检管理: 'Data quality management',
  数据质量报告: 'Data quality reports',
  数据整改: 'Data rectification',
  数据审批: 'Data approval',
  数据资产管理: 'Data assets',
  实体数据管理: 'Entity data management',
  数据资产检索: 'Data asset retrieval',
  数据资产目录: 'Data asset tree',
  实体关联管理: 'Entity aggregation',
  资产目录配置: 'Asset tree configuration',
  主题管理: 'Topic management',
  业务操作管理: 'Business operations management',
  属性业务操作配置: 'Property business action configuration',
  测点清单: 'List of measurement points',
  测点查询: 'Measurement point query',
  数据服务管理: 'Data Services',
  API发布: 'API release',
  API审核: 'API auditing',
  API申请: 'API application',
  数据映射: 'Data mapping',
  数据应用: 'Data applications',
  数据集: 'Data set',
  指标构图: 'Indicator composition',
  统计展示: 'Statistical display',
  参考数据管理: 'Reference Data Management',
  主数据管理: 'Master Data Management',
  主数据类型: '主数据类型',
  主数据清单: '主数据清单',
  主数据分发: '主数据分发',
}
